import React, { useEffect } from 'react';
import FullPageCarousel from '../Components/Carousel/FullPageCarousel';
import ImageCard from '../Components/ImageCard/ImageCard';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './PageCss/HomePage.css';
import SectionHeader from '../Components/SectionHeader/SectionHeader';
import { useMediaQuery } from 'react-responsive'; // Import useMediaQuery hook
import Promoter from '../Components/Promoter/Promoter';
import FeatureCardCarousel from '../Components/FeaturesCardCarousal/FeatureCardCarousal'
import AOS from 'aos';
import 'aos/dist/aos.css';
import NumberGrid from '../Components/NumberGrid/NumberGrid';
import { useTranslation } from 'react-i18next';

import qualitySticker from '../assets/QualityLogo.png';
import glob from '../assets/GlobLogo.png';
import hose from '../assets/HoseLogo.png';
import isoLogo from '../assets/ISO-Logo.png';
import imgCarton from '../assets/Hansa-Flex_Kartons_Shop.png';
import imgMobileService from '../assets/MobileService.jpg';
import ingIndustries_fr from '../assets/Industries Served-France translated.png';
import ingIndustries_en from '../../src/assets/WesiteCoverImage.jpg'
import imgHydraulicTraining from '../assets/Services/HydraulicAcademy/InHouseSeminars.jpg'
import imgManagementOfAssemblyHose from '../assets/home2.jpg'
import imgOperatorProtection from '../assets/news-events/Operator Protection.jpg'

import imgHose from '../assets/hose.jpg';
import imgAdaptar from '../assets/Products/HydraulicConnectionTechnology/Adapter/Stage.jpg'
import imgHyfraulicComponent from '../assets/Products/DriveAndControlTechnology/DriveAndControlTechnology/Stage.jpg'
import imgPressureAccumulator from '../assets/Products/DriveAndControlTechnology/PressureAccumulator/Stage.jpg'
import imgHydraulicCoupling from '../assets/Products/HydraulicConnectionTechnology/Couplings/HighFlow.jpg'
import imgPressureGauge from '../assets/Products/DriveAndControlTechnology/MeasuringTech/MeasuringConnection.jpg'

import imgCylinderRepair from '../assets/Services/RepairAndOverHaul/HydraulicCylinderRepair/EfficientOrder.jpg'
import imgEngineering from '../assets/Services/Engineering/Engineering_Centerspread.jpg'
import imgProduction from '../assets/Services/Production/Production/Production_Centerspread.jpg'
import imgAssemblyAndInstallation from '../assets/Services/AssemblyAndInstallation/AssemblyAndInstallation/Stage.jpg'

import imgCustomerSupport from '../assets/customer-support.png';
import Horizontal from '../Components/Horizontal/Horizontal';
import imgHANSA_FLEX_SERBIA_FLEXXPRESS from '../assets/Home/HANSA_FLEX_SERBIA_FLEXXPRESS.jpg'


function HomePage() {
  const { i18n, t } = useTranslation();
  var ingIndustries = ingIndustries_en;
  if (i18n.language === 'en') {
    ingIndustries = ingIndustries_en;
  }

  const isLaptop = useMediaQuery({ minWidth: 1024 }); // Define the breakpoint for laptop screen size
  const isMobile = window.innerWidth <= 768;


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);


  useEffect(() => {
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 320, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 300, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
  }, []);

  const featuresData = [
    {
      title: "Wide network",
      description: "With 9 branches (and growing) always near you",
      image: glob
    },
    {
      title: "Quality of products and services",
      description: "Same quality in HANSA-FLEX Serbia as all over the HANSA-FLEX world (Germany, Austria, USA, Australia…",
      image: qualitySticker
    },
    {
      title: "Reliability and Customer Support",
      description: "Always at your disposal for consulting",
      image: imgCustomerSupport
    },
    {
      title: "Expertise and Experience",
      description: "Over 20 years of work in Serbia and more than 60 years of experience worldwide.",
      image: hose
    }
    // Add more objects for additional FeaturesCard data
  ];

  //promoter content

  const promoterTitle = 'PLACE YOUR ORDER TODAY!';
  const promoterChecklistItems = [
    'The full HANSA-FLEX product range with more than 80,000 articles',
    'Category-specific filter parameters enable quick navigation',
    'Current availability shown in real-time for better planning certainty'
  ];
  const promoterButtonLabels = ['CONTACT US', 'FIND OUT MORE !'];

  //hall of fame
  const numbers = ['30,000+', '40,000+', '40,976'];
  const subtitles = ['Available parts in Serbia', 'Hoses built yearly in Serbia', 'X-CODES recorded in Serbia'];

  const googleReviewsLink = "https://www.google.com/search?sca_esv=8d768c6a0d450c4a&rlz=1C1GCEU_enIN1077IN1077&sxsrf=AHTn8zrfDNUQwuRsqJm6weDqmIMsLg1sLA:1741070305850&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzVHc83hdT89DECIhCN19ksQPoXH7a0yD_RkajEQLo-AyUak1k0gotOneALDWQSkmQi1otZkEjnuseon33eqYfxlgiapulev6Q0KwxmHD2nZq8njGeA%3D%3D&q=HANSA-FLEX+Hidraulika+d.o.o.+Reviews&sa=X&ved=2ahUKEwjy6u6o6O-LAxUHSWwGHZFsIeEQ0bkNegQIIBAE&biw=1536&bih=730&dpr=1.25";


  return (
    <div>
      <FullPageCarousel />

      <div>
        <SectionHeader
          title="Discover our products"
        />

        <Container className="custom-container">
          <Row>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-right"}>
              <ImageCard image={imgHose} learnMoreLink="/hydraulic-hoses" title="HANSA-FLEX PROVIDES PREMIUM QUALITY HOSES" desc="The HANSA-FLEX range includes hoses for hydraulics and pneumatics as well as for the transport of chemicals, food, air, water and abrasive media. In addition to standard hoses, we also supply suction and positive pressure hoses, suitable accessories and preassembled hose lines manufactured to your individual requirements. As a full-service provider, we also support our customers with installation, maintenance and inspection." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-right"}>
              <ImageCard image={imgAdaptar} learnMoreLink="/adapters" title="ADAPTERS" desc="Adapters create a safe and leak-free connection between components with differing thread types.HANSA-FLEX offers an extensive portfolio of hydraulic adapters, such as threaded or transition adapters in all common connection..." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-right"}>
              <ImageCard image={imgPressureAccumulator} learnMoreLink="/pressure-accumulators" title="HYDRAULIC ACCUMULATORS" desc="Hydraulic accumulators are used as pressure compensation vessels and balance temperature-related changes in volume and pressure peaks in hydraulic systems." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-left"}>
              <ImageCard image={imgHyfraulicComponent} learnMoreLink="/drive-and-control-tech" title="HYDRAULIC COMPONENTS" desc="Hydraulic components fulfil the highest quality standards at HANSA-FLEX, where quality management has DIN ISO 9001 certification. Availability is ensured by our warehouse, which stocks over 4,500 hydraulic components." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-left"}>
              <ImageCard image={imgHydraulicCoupling} learnMoreLink="/coupling" title="HYDRAULIC COUPLINGS" desc="Couplings are the best option in situations where attachments need to be quickly exchanged, machines safely connected or highly loaded hose lines on mobile and fixed hydraulic systems replaced." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-left"}>
              <ImageCard image={imgPressureGauge} learnMoreLink="/measuring-tech" title="PRESSURE GAUGES" desc="Measuring technology in hydraulic systems must be highly precise. Pressure, temperature and volumetric flow need to be measured accurately to ensure systems and machines operate reliably. Continuous condition monitoring can be an effective way to prevent wear on hydraulic components. Digital measuring instruments are becoming increasingly popular for the control and regulation of automatic processes." />
            </Col>
          </Row>
        </Container>

      </div>

      <div>
        <SectionHeader
          title="Our Services"
        />

        <Container className="custom-container">
          <Row>
            <Col sm={12} md={6} lg={8} data-aos={isMobile ? "fade-up" : "fade-right"}>
              <ImageCard image={imgHANSA_FLEX_SERBIA_FLEXXPRESS} learnMoreLink="/mobile-rapid-hydraulic-service" title="MOBILE HYDRAULIC SERVICE" desc="In the event of unforeseen hydraulic component failures, repairs must be made quickly. Our Mobile Hydraulic Service is available 24 hours a day, 7 days a week, 365 days a year and ensures minimal downtime." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-left"}>
              <ImageCard image={imgCylinderRepair} learnMoreLink="/hydraulic-cyclinder-repair" title="HYDRAULIC CYLINDER REPAIR" desc="Hydraulic cylinders are subject to extreme stresses due to their continual extending and retracting. The result is wear, which puts the whole working process at risk of failure. Overhauling a cylinder is..." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-up"}>
              <ImageCard image={imgEngineering} learnMoreLink="/engineering" title="ENGINEERING" desc="The experienced specialists at HANSA-FLEX support you in all tasks associated with the engineering and project planning of hydraulic systems and components from design to manufacture." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-up"}>
              <ImageCard image={imgProduction} learnMoreLink="/production" title="PRODUCTION" desc="In our production facilities we can manufacture anything from one-off items to large series production components as an OEM. Our employees and state-of-the-art machines mean we can achieve maximum flexibility and the..." />
            </Col>
            <Col sm={12} md={6} lg={4} data-aos={isMobile ? "fade-up" : "fade-up"}>
              <ImageCard image={imgAssemblyAndInstallation} learnMoreLink="/assembly-and-installation" title="ASSEMBLY AND INSTALLATION" desc="Our excellently trained service technicians carry out assembly and installation work on hydraulic systems." />
            </Col>
          </Row>
        </Container>

      </div>

      {/* <div>
        <SectionHeader
          title="Explore our units!"
          paragraph="We have our units in Pune, which provide extensive range of products!"
        />
        <ShowcaseCarousel carouselItems={carouselItems} descDisplay={isMobile ? 'none' : 'block'} />
      </div>
      <br /><br /><br /> */}

      <div className='div-gray center-all-items'>
        <SectionHeader
          title="Premium hydraulic and pneumatic solutions"
          subtitle="Select from more than 80,000 articles and always find the right product for your needs. We stock everything from A-Z."
        />
        <FeatureCardCarousel featuresData={featuresData} />
      </div>


      <div>
        {isLaptop && (
          <Promoter
            title={promoterTitle}
            checklistItems={promoterChecklistItems}
            btnLabel1={"Find Out More !"}
            btnLabel1Link={"https://shop.hansa-flex.rs/sr_RS/"}
            imageUrl={imgCarton}
          />
          // TODO: contact us button
        )}
      </div>

      {/* <div>
        <SectionHeader
          title="News and Events" />
        <Container className="custom-container">
          <Row>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/iree'} title="Operator protection – the right way!" desc={"Operator protection – the right way! From implementing stricter industrial health and safety regulations."} /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/product-training'} title="Size Matters: Calculating the Diameter of Hydraulic Hoses and Tubes" desc="Size Matters: Calculating the Diameter of Hydraulic Hoses and Tubes In hydraulic systems, choosing the correct inner diameter is essential." /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/goethe-event'} title="What you should know about hydraulic oils" desc="What You Should Know About Hydraulic Oils Hydraulic oils are an underrated component in plumbing systems. Many people simply." /></Col>
          </Row>
        </Container>
      </div> */}

      {/* <div>
        <SectionHeader
          title={"HANSA-FLEX Hydraulics Serbia"} /><br />
        <NumberGrid numbers={numbers} subtitles={subtitles} /><br /><br />

      </div> */}

      <br /><br /><br />

      <div className="text-center div-gray">
        <SectionHeader
          title={"Check out our reviews on google!"}
          paragraph={"Curious about what others have to say about us? Take a moment to explore our Google reviews and discover why our customers rave about their experiences with us."} />
        <br />
        <Button variant="primary" href={googleReviewsLink} target="_blank" className="btn-google" style={{ boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.2)' }}>{t("View our reviews on Google")}</Button>

        <br /><br /><br />
      </div>


      <br /><br /><br />

      <div>
        <SectionHeader title={"Industries served"} />
        <div className="home-imageContainer">
          {isMobile ? <>
            <img src={ingIndustries} alt="Description of the image" className='home-img' />

          </> : <>
            <img src={ingIndustries} alt="Description of the image" className='home-img' />

          </>}
        </div>

              <div>
        <Horizontal />
      </div>

       
      </div>


    </div>

  );
}

export default HomePage;
